import React from 'react';
import ErrorPanel from 'ff/debrief/layouts/ErrorPanel';
import Paper from '@mui/material/Paper';
import { useCurrentTracklog } from 'ff/debrief/hooks';

interface Props {}

const ErrorBar: React.FC<Props> = props => {
    const { isFailedUpload } = useCurrentTracklog();
    if (!isFailedUpload) return null;
    return (
        <ErrorPanel>
            <Paper
                sx={{
                    bgcolor: 'error.main',
                    color: 'error.contrastText',
                    py: 0.5,
                    px: 1,
                }}
            >
                Error loading track log
            </Paper>
        </ErrorPanel>
    );
};

export default ErrorBar;
